import { KeyRound, LogOut } from "zudoku/icons";
import {
  createProfileMenuPlugin,
  ProfileNavigationItem
} from "zudoku/plugins";

export const profileMenuPlugin = createProfileMenuPlugin({
  getProfileMenuItems: (): ProfileNavigationItem[] => {
    return [
      {
        label: "Test Console Keys",
        category: "middle",
        path: "/api-identities",
        icon: KeyRound,
      } satisfies ProfileNavigationItem,
      {
        label: "Logout",
        category: "bottom",
        path: "/logout",
        icon: LogOut,
      } satisfies ProfileNavigationItem,
    ];
  },
});
